import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { updateHideTooltipPreference } from '~/ProductPrice/actions';
import { ThunkDispatch } from '~/Store';

import MissingPricesTooltip from './MissingPricesTooltip';

function mapDispatchToProps(
	dispatch: ThunkDispatch<AnyAction>,
	ownProps: { onClose: () => void }
): { onClose: () => void } {
	return {
		onClose: () => {
			dispatch(updateHideTooltipPreference(true));
			ownProps.onClose();
		},
	};
}

export default connect(null, mapDispatchToProps)(MissingPricesTooltip);
